import React from 'react';

const StatementResponse = ({ question }) => {
  return <></>
};

export default StatementResponse;
